import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SAVED_FILTER_VIEWS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SAVED_FILTER_VIEWS');
export const SAVED_FILTER_VIEWS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SAVED_FILTER_VIEWS_CRUD_ACTION_CONSTANTS
);
